import { CASINO_PATHS, LIVE_CASINO_PATHS } from '../router/casino-routes';

const productNavRoutes = [
	'about',
	'responsible-gaming',
	'terms-and-conditions',
	'privacy_policy',
	'sportsbook',
	'live-betting',
	'shop',
	'promotions',
	'bonus',
	'payments',
	'virtuals',
	'user-feedback',
	'we-spin',
	'grytv',
	'thunderbite',
	'splash-tech'
]
	.map(i => `/${i}`)
	.concat([...CASINO_PATHS, ...LIVE_CASINO_PATHS]);

export default productNavRoutes;
